import { requireService } from '@profgeosoft/di-ez';
import {
  AddRoundLight,
  ChooseRow,
  CloseRoundLight,
  DoneLight,
  EditLightBig,
  SettingLineLight,
} from '@profgeosoft-ui/icons';
import { Button, Tooltip } from '@profgeosoft-ui/react';
import clsx from 'clsx';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { ImportButton } from 'src/features/import-modal';
import { wrap } from 'src/packages/mobx-di/wrap';

import type { MainDirectoryService } from 'src/services/directory-service/main-directory-service';

import styles from '../directory-page-header.module.scss';

type Props = {
  directory: MainDirectoryService;
  onTableSettingsClick(): void;
};

export const EditModeControls = wrap<Props>(function EditModeControls({ directory, onTableSettingsClick }) {
  const directoryPageHeader = requireService('directoryPageHeader');
  const directoryPage = requireService('directoryPage');
  const directoryListService = requireService('directoriesListService');
  const userService = requireService('userService');
  const { t } = useTranslation('appbar');

  const discardChanges = () => {
    if (!directoryPage.hasChanges) {
      directoryPage.setIsEditMode(false);
      directoryPage.setIsRowSelectionMode(false);
      directoryPage.removeSavedEditModeData();
      return;
    }

    directoryPageHeader.onEditModeOffByDiscard(() => {
      directory.discardChanges();
      directoryPage.removeSavedEditModeData();
    });
  };

  useEffect(() => {
    directoryListService.setIsDirectoryChangingBlocked(directoryPage.isEditing);
  }, [directoryListService, directoryPage.isEditing]);

  if (!directoryPage.isEditing) {
    return (
      <>
        {userService.userRole !== 'user' && (
          <Button
            variant="flat"
            className={styles.iconWrapper}
            onClick={() => {
              directoryPage.setIsEditMode(true);
              directoryPage.setIsRowSelectionMode(true);
            }}
          >
            <EditLightBig />
          </Button>
        )}
        <Button variant="flat" className={styles.iconWrapper} onClick={onTableSettingsClick}>
          <SettingLineLight />
        </Button>
        <Button
          className={clsx(styles.chooseRowButton, directoryPage.isRowSelectionModeOn && styles.pressed)}
          onClick={() => {
            directoryPage.setIsRowSelectionMode(!directoryPage.isRowSelectionModeOn);
          }}
        >
          <ChooseRow />
        </Button>
      </>
    );
  }

  return (
    <div className={styles.editModeWrapper}>
      {!directoryPage.currentDirectory?.view.rowsCreationIsBlocked && (
        <Button onClick={directoryPage.addNewRecord} icon={<AddRoundLight />}>
          {t('appbar.addButton')}
        </Button>
      )}
      <Button variant="danger" className={styles.quaterButton} onClick={discardChanges}>
        <CloseRoundLight />
      </Button>
      <Button
        variant="success"
        disabled={!directoryPage.hasChanges}
        className={styles.quaterButton}
        onClick={directoryPage.saveChanges}
      >
        <DoneLight />
      </Button>
      {/* Временно отключено */}
      {/* <div className={styles.iconWrapper}>
          <DetailVertCustom />
        </div> */}
      <Tooltip title={t('tooltips.notAvialable')}>
        <Button variant="flat" className={clsx(styles.iconWrapper, styles.disabled)} disabled={directoryPage.isEditing}>
          <SettingLineLight />
        </Button>
      </Tooltip>
      {directory.isImportAvailable && <ImportButton directory={directory} className={styles.iconWrapper} />}
    </div>
  );
});
